import styled from 'styled-components';

export const OfferCardContainer = styled.div`
  .coupon-card-desc::after,
  .coupon-card-desc::before,
  .coupon-card-apply::after,
  .coupon-card-apply::before {
    content: '';
    display: block;
    width: 1rem;
    height: 1rem;
    background-color: #ffffff;
    position: absolute;
    z-index: 2;
  }

  .coupon-card-desc::before {
    top: 50%;
    left: 0;
    border-bottom-right-radius: 100%;
    box-shadow: 1px -1px #ffffff;
  }

  .coupon-card-desc::after {
    bottom: 50%;
    left: 0;
    border-top-right-radius: 100%;
    box-shadow: 1px -1px #ffffff;
  }

  .coupon-card-apply::after {
    right: 0;
    bottom: 50%;
    border-top-left-radius: 100%;
    box-shadow: 1px -1px #ffffff;
  }

  .coupon-card-apply::before {
    top: 50%;
    right: 0;
    border-bottom-left-radius: 100%;
    box-shadow: 1px -1px #ffffff;
  }

  .coupon-card-apply,
  .coupon-card-desc {
    position: relative;
  }
`;
